import { StyleSheet, View } from "react-native";

import { useTranslation } from "@luna-restaurant/i18n";

import { useCustomTheme } from "../hooks/useCustomTheme";
import { Icon } from "./Icon";
import { ThemedText } from "./ThemedText";

export const ReportSentAlert = () => {
  const { colors } = useCustomTheme();
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      <Icon
        size={28}
        color={colors.border}
        iconSet="material-community"
        icon="information"
      />
      <ThemedText style={{ color: colors.border }} type="subtitle">
        {t("common.lunaWasInformed")}
      </ThemedText>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 16,
  },
});
